import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get, map } from 'lodash';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { Step, StepLabel } from '@material-ui/core';

import { Typography, Stepper } from 'embeds/components';

import Connector from './Connector';

const styles = ({
  custom: {
    palette: { colorSuccess },
  },
  spacing: { unit },
}) => ({
  errorText: {
    textAlign: 'center',
    '&$left': {
      textAlign: 'left',
    },
    '&$right': {
      textAlign: 'right',
    },
  },
  left: {},
  right: {},
  root: {
    backgroundColor: 'transparent',
    padding: `${unit * 2}px 0px`,
  },
  stepAlternativeLabel: {
    '&$left': {
      textAlign: 'left',
    },
    '&$right': {
      textAlign: 'right',
    },
  },
  completed: {
    color: `${colorSuccess} !important`,
  },
  stepLabel: {
    '&$left': {
      alignItems: 'flex-start',
    },
    '&$right': {
      alignItems: 'flex-end',
    },
  },
});

class UploadStepper extends PureComponent {
  constructor(props) {
    super(props);

    this.renderStep = this.renderStep.bind(this);
  }

  renderStep(step, index) {
    const { activeStep, classes, error, fileData, uploadError } = this.props;
    const failedUpload = activeStep === 0 && activeStep === index && Boolean(uploadError);
    const failedReview =
      activeStep === 1 && activeStep === index && parseInt(get(fileData, 'recordsCreated', '0'), 10) === 0;
    const otherError = activeStep === 2 && activeStep === index && error;
    const optional = failedUpload && (
      <Typography
        variant="caption"
        className={classnames(classes.errorText, {
          [classes.left]: index === 0,
          [classes.right]: index === 2,
        })}
        color="error"
      >
        Empty or invalid file, please select a valid CSV file.
      </Typography>
    );
    const stepIconProps = {
      classes: {
        completed: classes.completed,
      },
    };

    return (
      <Step key={step}>
        <StepLabel
          classes={{
            root: classnames(classes.stepLabel, { [classes.left]: index === 0, [classes.right]: index === 2 }),
            alternativeLabel: classnames(classes.stepAlternativeLabel, {
              [classes.left]: index === 0,
              [classes.right]: index === 2,
            }),
          }}
          error={failedUpload || failedReview || otherError}
          optional={optional}
          StepIconProps={stepIconProps}
        >
          {step}
        </StepLabel>
      </Step>
    );
  }

  render() {
    const { classes, activeStep } = this.props;
    const steps = ['Upload file', 'Review', 'Complete'];

    return (
      <Stepper activeStep={activeStep} alternativeLabel className={classes.root} connector={<Connector />}>
        {map(steps, this.renderStep)}
      </Stepper>
    );
  }
}

UploadStepper.propTypes = {
  classes: PropTypes.object.isRequired,
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  fileData: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  uploadError: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
};

export default withStyles(styles)(UploadStepper);
